import React from 'react';

export default function RoleCircle({ role, onClick, selected }) {
  const isHost = role === 'host';
  const label = isHost ? 'Host' : 'Guest';
  const descriptor = isHost
    ? "Invite the people you'd like to connect with instantly through video"
    : 'Set your rate. Connect on your terms';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`ic-role-circle-wrap ${selected ? 'is-selected' : ''}`}
      aria-pressed={selected ? 'true' : 'false'}
    >
      <div className={`ic-role-circle ${isHost ? 'is-host' : 'is-guest'}`}>
        <span>{label}</span>
      </div>
      <p>{descriptor}</p>
    </button>
  );
}
